import { NavButtonProps } from '../types'
import { cn } from '../../../shared/lib/utils'

const NavButton = ({ isCollapsed, icon, text, smallScreenText, isActive, onNavigate, isDisabled }: NavButtonProps) => {
  return (
    <button
      onClick={() => !isDisabled && onNavigate()}
      disabled={isDisabled}
      className={cn(
        "flex md:flex-col lg:flex-row items-center gap-2 w-11/12 py-2 pr-2 hover:bg-gray-50 transition-all whitespace-nowrap duration-200 text-sm relative",
        isActive ? "text-gray-30 font-bold" : "text-gray-10 font-[350]",
        isDisabled ? "opacity-50 cursor-not-allowed" : "",
        isCollapsed ? "lg:flex-col md:w-[72px] text-xs md:p-2 justify-center md:text-center items-center text-center md:whitespace-normal truncate" : "lg:flex-row lg:w-full"
      )}
    >
      <span>
        {icon(isActive)}
      </span>
      <span className="hidden lg:block">{isCollapsed ? smallScreenText : text}</span>
      <span className="block lg:hidden">{smallScreenText}</span>

      {(!isCollapsed && isActive) && <div className="block md:hidden lg:block w-1 h-4 bg-primary-20 rounded-[4px] absolute right-1" />}
    </button>
  )
}

export default NavButton
